import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AuthSelectors } from '@/app/+state/auth';
import { ChallengeStorageService } from '@/app/core/services';

@Injectable()
export class ChallengeInterceptor implements HttpInterceptor {
    private store = inject(Store);
    private challengeStorage = inject(ChallengeStorageService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authChallengeToken = this.store.selectSignal(AuthSelectors.selectAuthChallengeToken)();

        if (!authChallengeToken) {
            authChallengeToken = this.challengeStorage.getAuthChallengeToken();

            if (authChallengeToken && this.challengeStorage.isTokenExpired()) {
                this.challengeStorage.clearChallenge();
                authChallengeToken = null;
            }
        }

        if (authChallengeToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authChallengeToken}`,
                },
            });
        }

        return next.handle(request);
    }
}
